import React, {RefObject} from 'react';
import { View, Text, TouchableOpacity, Platform } from 'react-native';
import styles from '../../styles/AppStyles';
import { ProductImage } from '../types/LandingPageTypes';

interface ImageUploaderProps {
  productImages: ProductImage[];
  handleImagePick: () => void;
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleRemoveImage: (index: number) => void;
  imageInputRef: RefObject<HTMLInputElement | null>;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
  productImages,
  handleImagePick,
  handleImageChange,
  handleRemoveImage,
  imageInputRef,
}) => {
  const maxImages = 3;
  const canAddMore = productImages.length < maxImages;

  return (
    <>
      <View style={styles.uploadBox}>
        <Text style={styles.boxLabelTextFilePicker}>
          {productImages.length > 0 
            ? `Selected ${productImages.length} of ${maxImages} images for product placement` 
            : 'No Product Images Selected (Up to 3)'}
        </Text>
        {productImages.length > 0 && (
          <View style={{marginTop: 8}}>
            {productImages.map((img, index) => {
              // Truncate long filenames
              const maxLength = 50;
              const displayName = img.name.length > maxLength 
                ? img.name.substring(0, 25) + '...' + img.name.substring(img.name.length - 22)
                : img.name;
              
              return (
                <View key={index} style={{flexDirection: 'row', alignItems: 'center', marginBottom: 4}}>
                  <Text style={{flex: 1, fontSize: 14, color: '#fff'}} numberOfLines={1} ellipsizeMode="middle">
                    {index + 1}. {displayName}
                  </Text>
                  <TouchableOpacity 
                    onPress={() => handleRemoveImage(index)}
                    style={{marginLeft: 8, padding: 4}}
                  >
                    <Text style={{color: '#ff0000', fontSize: 14}}>✕ Remove</Text>
                  </TouchableOpacity>
                </View>
              );
            })}
          </View>
        )}
      </View>

      <View style={styles.buttonRow}>
        <TouchableOpacity 
          style={[
            styles.button, 
            styles.secondaryButton, 
            !canAddMore && styles.removeBtnDisabled,
            {marginBottom: 6}
          ]} 
          onPress={handleImagePick}
          disabled={!canAddMore}
        >
          <Text style={styles.secondaryButtonText}>
            {productImages.length > 0 ? 'Add Another Image' : 'Upload Images'}
          </Text>
        </TouchableOpacity>
      </View>

      {Platform.OS === 'web' && (
        <input
          ref={imageInputRef}
          type="file"
          accept="image/*"
          multiple
          style={{ display: 'none' }}
          onChange={handleImageChange}
        />
      )}
    </>
  );
};

export default ImageUploader;
